export class SIRIValue {
  sheetValue: string;
  redcapValue: string;

  constructor(sheetValue: string, redcapValue: string) {
    this.sheetValue = sheetValue;
    this.redcapValue = redcapValue;
  }
}
